import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const JABATAN_LIST = ['Direktur', 'Komisaris', 'Lainnya'];

export default function Pengurus({ companyId }) {
  const [list, setList] = useState([]);
  const [docs, setDocs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nama: '', jabatan: 'Direktur', keterangan: '', dokumen_ids: [] });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { loadAll(); }, [companyId]);

  const loadAll = async () => {
    try {
      const params = companyId ? { company_id: companyId } : {};
      const [r1, r2] = await Promise.all([
        axios.get(`${API}/api/officers`, { params }),
        axios.get(`${API}/api/documents`, { params })
      ]);
      setList(r1.data);
      setDocs(r2.data);
    } catch {}
  };

  const openAdd = () => { setEditing(null); setForm({ nama: '', jabatan: 'Direktur', keterangan: '', dokumen_ids: [] }); setShowForm(true); };
  const openEdit = (o) => { setEditing(o.id); setForm({ nama: o.nama, jabatan: o.jabatan, keterangan: o.keterangan || '', dokumen_ids: o.dokumen_ids || [] }); setShowForm(true); };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      const params = companyId ? { company_id: companyId } : {};
      if (editing) {
        await axios.put(`${API}/api/officers/${editing}`, form);
      } else {
        await axios.post(`${API}/api/officers`, form, { params });
      }
      setMsg(editing ? 'Pengurus diperbarui!' : 'Pengurus ditambahkan!');
      setShowForm(false); loadAll();
    } catch { setMsg('Gagal menyimpan'); } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus pengurus ini?')) return;
    await axios.delete(`${API}/api/officers/${id}`); loadAll();
  };

  const toggleDoc = (id) => {
    setForm(f => ({ ...f, dokumen_ids: f.dokumen_ids.includes(id) ? f.dokumen_ids.filter(x => x !== id) : [...f.dokumen_ids, id] }));
  };

  if (companyId === null) return <div style={s.empty}>Pilih perusahaan terlebih dahulu dari menu "Semua Perusahaan"</div>;

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.h2}>👤 Pengurus Perusahaan</h2>
        <button style={s.addBtn} onClick={openAdd}>+ Tambah Pengurus</button>
      </div>
      {msg && <div style={{ ...s.msg, color: msg.includes('berhasil') || msg.includes('ditambah') || msg.includes('diperbarui') ? '#16a34a' : '#dc2626' }}>{msg}</div>}

      {showForm && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>{editing ? 'Edit Pengurus' : 'Tambah Pengurus'}</h3>
          <form onSubmit={handleSubmit}>
            <div style={s.row}>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Nama</label>
                <input style={s.input} value={form.nama} onChange={e => setForm(f => ({ ...f, nama: e.target.value }))} required placeholder="Nama lengkap" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Jabatan</label>
                <select style={s.input} value={form.jabatan} onChange={e => setForm(f => ({ ...f, jabatan: e.target.value }))}>
                  {JABATAN_LIST.map(j => <option key={j}>{j}</option>)}
                </select>
              </div>
            </div>
            {form.jabatan === 'Lainnya' && (
              <div style={s.field}>
                <label style={s.label}>Keterangan Jabatan</label>
                <input style={s.input} value={form.keterangan} onChange={e => setForm(f => ({ ...f, keterangan: e.target.value }))} placeholder="Jabatan lainnya..." required />
              </div>
            )}
            {docs.length > 0 && (
              <div style={s.field}>
                <label style={s.label}>Kaitkan dengan Dokumen</label>
                <div style={s.docList}>
                  {docs.map(d => (
                    <label key={d.id} style={s.checkRow}>
                      <input type="checkbox" checked={form.dokumen_ids.includes(d.id)} onChange={() => toggleDoc(d.id)} />
                      <span>{d.jenis}{d.keterangan_lainnya ? ` (${d.keterangan_lainnya})` : ''} - v{d.version} - {d.original_filename}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div style={s.formActions}>
              <button type="button" style={s.cancelBtn} onClick={() => setShowForm(false)}>Batal</button>
              <button type="submit" style={s.saveBtn} disabled={saving}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
            </div>
          </form>
        </div>
      )}

      {list.length === 0 ? (
        <div style={s.empty}>Belum ada pengurus. Klik "+ Tambah Pengurus".</div>
      ) : (
        <div style={s.cards}>
          {list.map(o => (
            <div key={o.id} style={s.card}>
              <div style={s.cardTop}>
                <div>
                  <div style={s.name}>{o.nama}</div>
                  <div style={s.jabBadge}>{o.jabatan === 'Lainnya' ? o.keterangan : o.jabatan}</div>
                </div>
                <div style={s.cardActions}>
                  <button style={s.editBtn} onClick={() => openEdit(o)}>Edit</button>
                  <button style={s.delBtn} onClick={() => handleDelete(o.id)}>Hapus</button>
                </div>
              </div>
              {o.dokumen_ids?.length > 0 && (
                <div style={s.docsLinked}>
                  📎 {o.dokumen_ids.length} dokumen terkait
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  h2: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', margin: 0 },
  addBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  msg: { padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', background: '#f0fdf4' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  formTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#1a1a2e' },
  row: { display: 'flex', gap: '12px', marginBottom: '12px' },
  field: { marginBottom: '12px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '5px' },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  docList: { display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '120px', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '8px' },
  checkRow: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' },
  formActions: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  cancelBtn: { padding: '8px 18px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  saveBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' },
  cards: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' },
  card: { background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  name: { fontSize: '16px', fontWeight: '600', color: '#1a1a2e', marginBottom: '4px' },
  jabBadge: { background: '#eff6ff', color: '#1d4ed8', borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: '600', display: 'inline-block' },
  cardActions: { display: 'flex', gap: '6px' },
  editBtn: { padding: '4px 10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  delBtn: { padding: '4px 10px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  docsLinked: { marginTop: '10px', fontSize: '12px', color: '#6b7280', borderTop: '1px solid #f3f4f6', paddingTop: '8px' },
  empty: { background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }
};
